import React from 'react';

const QueEsEneagrama = () => {
    return (
        <div className="section-container">
            <h2>¿Qué es el Eneagrama?</h2>
            <p>
                El Eneagrama de la Personalidad es mucho más que un sistema de clasificación psicológica: 
                es un mapa de autoconocimiento y transformación personal. Describe nueve tipos de carácter, 
                cada uno con su propia forma de pensar, sentir e interpretar el mundo, así como sus motivaciones, 
                miedos y patrones de comportamiento específicos.
            </p>
            <h3>🧠 Comprender la personalidad desde una visión integradora</h3>
            <p>
                El Eneagrama no solo nos ayuda a identificar quiénes somos, sino que también nos permite comprender 
                la neurosis y el desarrollo de la personalidad desde una perspectiva profunda. Cada eneatipo está vinculado a:
            </p>
            <ul className="eneagrama-list">
                <li>🔹 Una pasión dominante, que representa una emoción central en nuestra forma de ser.</li>
                <li>🔹 Una fijación cognitiva, que influye en nuestra percepción de la realidad.</li>
            </ul>
            <p>
                Reconocer estos patrones nos ayuda a identificar las estrategias defensivas del ego y cómo afectan 
                nuestra relación con nosotros mismos, con los demás y con el mundo.
            </p>
            <h3>🌿 Un camino hacia la transformación</h3>
            <p>
                El Eneagrama no es solo una herramienta de tipificación, sino una guía para el desarrollo personal. 
                Nos permite detectar las distorsiones cognitivas y emocionales que nos limitan y nos ofrece un camino de 
                liberación basado en el autoconocimiento, el desarrollo personal y la espiritualidad.
            </p>
            <h3>✨ Descubre quién eres más allá del ego.</h3>
            <div className="image-container">
                <img src="/images/eneagrama1.png" alt="Eneagrama" />
            </div>
        </div>
    );
};

export default QueEsEneagrama;
